/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close magnified preview" |
*
* @param {Image_Export_Magnified_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_close_label = /** @type {((inputs?: Image_Export_Magnified_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la previsualisation agrandie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergrößerte Vorschau schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi anteprima ingrandita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличенный фрагмент предварительного просмотра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar vista ampliada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭放大预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡大プレビューを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम करके देखने का पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização ampliada aproximada")
	return /** @type {LocalizedString} */ ("Close magnified preview")
});